import { reactify } from '@zeiss/zui-react';
export const ZuiIconMedFilterRetinaProtect = reactify('zui-icon-med-filter-retina-protect');
